<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiTicketwindowQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="售票窗口查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">窗口名称：</div>
						<a-input v-model="query.ticketwindowName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiTicketwindowQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						[{{mainNavigation[0].facilitatorName}}] 窗口列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="ticketwindowId" :loading="tableLoading" :pagination="false">
				<span slot="ticketwindowName" slot-scope="ticketwindowName">
					<a-button type="link" @click="edit(ticketwindowName)" >{{ticketwindowName.ticketwindowName}}</a-button>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{mainNavigation[0].facilitatorName}}
				</span>
				<span slot="ticketwindowState" slot-scope="ticketwindowState">
					<span v-if="ticketwindowState == 2">禁用</span>
					<span v-if="ticketwindowState == 3">启用</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="salewindowManage(tableAction)">销售权限</a-button>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="窗口名称" has-feedback prop="ticketwindowName">
					<a-input v-model="addForm.ticketwindowName" placeholder="请输入售票窗口名称" />
				</a-form-model-item>
				<a-form-model-item label="所属服务商" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" @change="addSelectFacilitator">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="所属售票站点" has-feedback prop="ticketstationId">
					<a-select v-model="addForm.ticketstationId" >
						<a-select-option v-for="(item,index) in ticketstation" :value="item.ticketstationId" :key="index">{{item.ticketstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="MAC地址" has-feedback prop="mac">
					<a-input v-model="addForm.mac" placeholder="请输入MAC地址" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="ticketwindowState">
					<a-radio-group name="ticketwindowState" v-model="addForm.ticketwindowState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="窗口名称" has-feedback prop="ticketwindowName">
					<a-input v-model="editForm.ticketwindowName" placeholder="请输入售票窗口名称" />
				</a-form-model-item>
				<a-form-model-item label="所属服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" @change="addSelectFacilitator" disabled>
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="所属售票站点" has-feedback prop="ticketstationId">
					{{editForm.ticketstationName}}
				</a-form-model-item>
				<a-form-model-item label="MAC地址" has-feedback prop="mac">
					<a-input v-model="editForm.mac" placeholder="请输入MAC地址" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="ticketwindowState">
					<a-radio-group name="ticketwindowState" v-model="editForm.ticketwindowState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//服务商列表
				facilitatorList: [],
				//售票站点列表
				ticketstation: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					ticketwindowName: '',
				},
				mainNavigation:[ {facilitatorName: ''} ],
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'ticketwindowId', key:'ticketwindowId', align:'center'},
					{ title:'窗口名称', key:'ticketwindowName', align:'center', scopedSlots:{customRender:'ticketwindowName'}},
					{ title:'所属服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'所属站点', key:'ticketstationName', dataIndex:'ticketstationName', align:'center'},
					{ title:'MAC地址', key:'tel', dataIndex:'mac',align:'center'},
					{ title:'状态', dataIndex:'ticketwindowState', key:'ticketwindowState', align:'center', scopedSlots:{customRender:'ticketwindowState'}},
					{ title: '操作', key: 'tableAction', align: 'center', scopedSlots: { customRender: 'tableAction' } },
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					ticketwindowName: '',
					facilitatorId: '',
					ticketstationId: '',
					mac: '',
					ticketwindowState: 3,
					remarks: '',
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					ticketstationId: [{ required: true, message: '请选择售票站点', trigger: 'blur' }],
					ticketwindowName: [{ required: true, message: '售票站点名称不能为空', trigger: 'blur' }],
					ticketwindowState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					ticketwindowId: '',
					ticketwindowName: '',
					facilitatorId: '',
					ticketstationId: '',
					mac: '',
					ticketwindowState: 3,
					remarks: '',
				},
				// 修改弹窗-end
				
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,this.query);
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiTicketwindowQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取售票站点列表
			async apiTicketstationList(id) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationList,{'facilitatorId':id});
				if (res.code == 200) {
					this.ticketstation = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			//添加弹窗服务商下拉框
			addSelectFacilitator(e){
				this.apiTicketstationList(e)
			},

			//表格开始-搜索
			async apiTicketwindowQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketwindowQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiTicketwindowQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiTicketwindowQueryList()
			},
			async apiTicketwindowAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketwindowAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiTicketwindowQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiTicketwindowAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			async apiTicketwindowEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketwindowEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiTicketwindowQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiTicketwindowEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.ticketwindowId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.ticketwindowName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiTicketwindowDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiTicketwindowDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketwindowDel, {ticketwindowId: this.tableSelectedRows.ticketwindowId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiTicketwindowQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.ticketwindowId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			//销售权限
			salewindowManage(e){
				let salewindowManageMain = []
				salewindowManageMain[0] = {'facilitatorId': this.mainNavigation[0].facilitatorId, 'facilitatorName': this.mainNavigation[0].facilitatorName}
				salewindowManageMain[1] = {'ticketstationId': e.ticketstationId, 'ticketstationName': e.ticketstationName}
				salewindowManageMain[2] = {'ticketwindowId': e.ticketwindowId, 'ticketwindowName': e.ticketwindowName}
				window.sessionStorage.setItem("salewindowManageMain", JSON.stringify(salewindowManageMain))
				console.log(window.sessionStorage.getItem("salewindowManageMain"));
				this.$router.push('/Salewindow')
			},
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
